const ENV = {
    FLAG_SYSTEM: process.env.REACT_APP_FLAG_SYSTEM!,
    APP_ENDPOINT: process.env.REACT_APP_ENDPOINT!,
    MOBILE_ENDPOINT: process.env.REACT_APP_MOBILE_ENDPOINT!,
    CNPJA_KEY: process.env.REACT_APP_CNPJA_KEY!,
}

export default ENV